export { zhRegExpWithPluginEnabled as zhRegExp } from 'regexp-cjk-with-plugin-enabled';
export { zhRegExpWithPluginEnabled as default } from 'regexp-cjk-with-plugin-enabled';
